<template>
  <div class="vx-col w-full mb-5" >
    <vs-button v-if="!isDisabled" color="primary" type="border" icon-pack="feather" class="mb-4"  @click="addLocationTestimony()">Agregar referencia</vs-button>   
    <vx-tooltip text="Envía una notificación al solicitante para que contacte a sus referencias y les solicite completar la información requerida vía telefónica." placement="top">
      <vs-button @click.stop="requestApplicantSendWhatsappNotification()" class="mb-4" type="border" size="small">Notificar al solicitante de contacto a sus referencia</vs-button>
    </vx-tooltip>
        
      <vs-table stripe noDataText="No se han generado registros" :data="testimonies">
        <template slot="thead">
          <vs-th class="bold">NOMBRE</vs-th>
          <vs-th class="bold">CORREO</vs-th>
          <vs-th class="bold">ESTATUS DE CORREO</vs-th>
          <vs-th class="bold">TELÉFONO</vs-th>
          <vs-th class="bold">TIPO DE RELACIÓN</vs-th>
          <vs-th class="bold">¿EXISTE?</vs-th>
          <vs-th class="bold">¿RECIBE LLAMADAS?</vs-th>
          <vs-th class="bold">ACCIONES</vs-th>
        </template>

        <template slot-scope="{data}">
          <vs-tr :key="indextr" v-for="(tr, indextr) in data">

            <vs-td :data="data[indextr].name">
              {{ data[indextr].name }}
            </vs-td>

            <vs-td :data="data[indextr].email">
              {{ data[indextr].email }}
            </vs-td>

            <vs-td :data="data[indextr].email_verification_response">
              {{ getEmailVerificationResponse(data[indextr].email_verification_response) }}
            </vs-td>

            <vs-td :data="data[indextr].phone_id">
              {{ data[indextr].phone != null ? phoneFormat(data[indextr].phone.phone) : "--"}}
            </vs-td>

            <vs-td :data="data[indextr].relation_type" class="table-wrap">
              {{ nameForRelationType(data[indextr].relation_type) }}
            </vs-td>
            <vs-td>
              <vs-checkbox v-model="data[indextr].phone_exist" @change="phoneExistHandle(data[indextr])"></vs-checkbox>
            </vs-td>
            <vs-td>
              <vs-checkbox v-model="data[indextr].receive_calls" @change="receiveCallHandle(data[indextr])"></vs-checkbox>
            </vs-td>
            <vs-td :data="data[indextr].id">
              <template v-if="!isDisabled">
                <div class="flex">
                  <feather-icon icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current cursor-pointer" class="ml-6" @click.stop="removeItemRequest(data[indextr])" />
                  <feather-icon icon="EditIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current cursor-pointer" class="ml-6" @click.stop="setEditForm(data[indextr])" />
                  <feather-icon v-if="data[indextr].phone_id != null" icon="PhoneForwardedIcon" svgClasses="w-5 h-5 hover:text-warning stroke-current cursor-pointer" class="ml-6" @click.stop="requestSendWhatsappNotification(data[indextr])" />
                </div>
              </template>
              <p v-else>Sin acciones disponibles</p>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>

      <vs-popup
        :title="isEditing ? 'Editar referencia' : 'Agregar referencia'"
        :active.sync="showFormPrompt">
        <div class="con-exemple-prompt">
          <vs-alert v-if="onError" class="h-full mb-5" color="danger">
            <span>{{ errorMssg }}</span>
          </vs-alert>
          <vs-alert v-if="onSuccess" class="h-full mb-5" color="success">
            <span>{{ successMssg }}</span>
          </vs-alert>

          <p class="mb-5 bold">{{formPromptIndication}}</p>

          <vs-input
            class="w-full mb-4" 
            label="Nombre completo"
            placeholder="Requerido"
            v-validate="'required'"
            v-on="{input: e => {name = upper(e) }}"
            data-vv-name="name"
            :danger="hasError('name')"
            :danger-text="errorText('name')"
            :success="isSuccess('name')"
            v-model.lazy="name" /> 

            <vs-input
            class="w-full mb-4" 
            label="Correo"
            placeholder="Requerido"
            v-validate="'required|email'"
            data-vv-name="email"
            :danger="hasError('email')"
            :danger-text="errorText('email')"
            :success="isSuccess('email')"
            v-model.lazy="email" />  

            <vs-input
            class="w-full mb-4" 
            label="Celular a 10 dígitos"
            placeholder="Requerido"
            v-validate="'required|digits:10'"
            data-vv-name="phone"
            icon-pack="feather"
            icon="icon-phone"
            :danger="hasError('phone')"
            :danger-text="errorText('phone')"
            :success="isSuccess('phone')"
            v-model.lazy="phone" />

          <!-- Campos tipo select -->
          <!-- <vx-select class="w-full mb-5" 
            label="Tipo de relación" 
            v-model.lazy="relation_type"
            name="relation_type"
            v-validate="'required'"
            :danger="hasError('relation_type')"
            :danger-text="errorText('relation_type')"
            :success="isSuccess('relation_type')"
            placeholder="Seleccione una opción" >
            <vx-select-item :key="index" :value="item.value" :text="item.text" v-for="(item,index) in getOptionsForSelect" class="w-full" />
          </vx-select> -->

          <label for="" class="vs-input--label">Tipo de Relación</label>
          <v-select
            label="text"
            name="relation_type"
            class="vs-custom w-full mb-5"
            v-model.lazy="relation_type"
            v-validate="'required'"
            :options="getOptionsForSelect"
            :reduce="text => text.value"
            :clearable="false"
            :searchable="false"
            placeholder="Seleccione una opción"       
          >
          </v-select>
          <v-error v-if="hasError('relation_type')" :error="errorText('relation_type')" :success="isSuccess('relation_type')" />

          <vs-button v-if="!isEditing" :disabled="!completeForm || $isLoading" @click="saveTestimony" color="primary" class="mr-5 mt-2">Agregar</vs-button>
          <vs-button v-else :disabled="!completeForm || $isLoading" @click="updateTestimony" color="black" class="mr-5 mt-2">Guardar</vs-button>
          <vs-button @click="closeFormPrompt" :disabled="$isLoading" type="flat" color="primary">Cerrar</vs-button>
            
        </div>
      </vs-popup>

    </div>

</template>

<script>
import inputHelper from "@mixins/inputHelper"
import formatHelper from "@mixins/formatHelper"
import { data } from "jquery";
const indicationDef = "Ingresa todos los datos solicitados para generar la referencia.";
const errorMssgDef = "Ha ocurrido un error al agregar la referencia, intente más tarde."
const successMssgDef = "La referencia ha sido agregada exitosamente"
const statePresenceVal = 0;
const cityPresenceVal = 1;

export default {
  name: 'applicant-references-control',
  mixins: [inputHelper, formatHelper],
  props: {
    applicant_id: { type: [String,Number], required: true },
    isDisabled: { type: [String,Boolean], default: false },
    userId: { type: [String,Number], required: true },
    projectId: { type: [String,Number], required: true },
  },
  data(){
    return {
      name: null,
      phone: null,
      relation_type: null,
      email: null,

      relationTypes: [],
      getOptionsForSelect: [],
      testimonies: [],

      showFormPrompt: false,
      selectedTestimony: null,

      onError: false,
      onSuccess: false,
      errorMssg: errorMssgDef,
      successMssg: successMssgDef,
      formPromptIndication: indicationDef,
      isEditing: false,
      currentReference: null
    }
  },
  mounted: async function(){
    await this.getCollections();
    await this.loadSavedTestimonies();
  },
  computed: {
    completeForm(){
      return this.relation_type != null && this.name != null && this.phone != null && this.email != null;
    }
  },
  methods: {
    setEditForm(tr) {
      this.isEditing = true;
      this.currentReference = tr;
      this.showFormPrompt = true;
      this.name = this.currentReference.name;
      this.email = this.currentReference.email;
      this.phone = this.currentReference.phone != null ? this.currentReference.phone.phone : null;
      this.relation_type = this.currentReference.type;
      console.log(tr);
    },
    async phoneExistHandle(reference) {
      this.$vs.loading();

      try {
        await axios.patch(`/api/applicant/${reference.client_id}/reference/${reference.id}`, {
          phone_exist: 1
        })

        this.$vs.loading.close();
      } catch (e) {
        this.errorNotif('Error', 'Ha ocurrido un error al actualizar la referencia')
        this.$vs.loading.close();
      }
    },
    async receiveCallHandle(reference) {
      this.$vs.loading();

      try {
        await axios.patch(`/api/applicant/${reference.client_id}/reference/${reference.id}`, {
          receive_calls: 1
        })

        this.$vs.loading.close();
      } catch (e) {
        this.errorNotif('Error', 'Ha ocurrido un error al actualizar la referencia')
        this.$vs.loading.close();
      }
    },
    getEmailVerificationResponse(emailVerificationResponse) {
      switch(emailVerificationResponse) {
        case 'sent': 
          return 'Enviado';
        case 'open':
          return 'Abierto';
        case 'click': 
          return 'Entregado y abierto (Clic en link dentro del correo)';
        case 'delivery': 
          return 'Entregado';
        case 'bounce': 
          return 'No se entregó (Rebotó)';
        case 'spam_complaint': 
          return 'Definido como spam';
        case 'subscription_change': 
          return 'Entregado y abierto (Dado de baja)';
      }
    },
    async getCollections(){
      try {
        let res = await axios.get("/api/v1/forms/getProjectRelatedProfilesRelationTypes");
        this.relationTypes = res.data;

        let options = [];
        this.relationTypes.forEach(opt => {
          options.push({value: opt.type, text: opt.name}); //conversion a sintaxis de vx-select 
        })
        this.getOptionsForSelect = options;
      } catch (error) {
        this.warn(error);
      }
    },
    async loadSavedTestimonies(){
      try {
        let params = "?with[]=references.phone";
        let response = await axios.get(`/api/v1/applicant/${this.applicant_id}${params}`);
        this.testimonies = response.data.references;//.filter(f => f.family_group_id == this.family_group_id);
      }
      catch (e) {
        this.warn(e);
      }      
    },
    nameForRelationType(type){
      let ff = this.relationTypes.find(f => f.type == type);
      if(ff){
        return ff.name;
      }
    },
    removeItemRequest(testimony){
      this.selectedTestimony = testimony;

      this.$vs.dialog({
        type: 'confirm',
        color: 'warning',
        title: 'Eliminar referencia',
        text: `¿Realmente desea eliminar la referencia con nombre ${testimony.name}?`,
        acceptText: "Eliminar",
        cancelText: 'Cancelar',
        accept: this.doRemoveItem
      });
    },
    async doRemoveItem(){
      this.showLoading(true);
      try {
        let payload = {project_related_profile_id: this.selectedTestimony.id};
        await axios.post(`/api/v1/applicant/${this.applicant_id}/removeReference`, payload);
        await this.loadSavedTestimonies();
      }
      catch (error) {
        this.warn(error);
      }
      this.showLoading(false);
    },
    async saveTestimony(){
      this.onSuccess = false;
      this.onError = false;
      
      this.showLoading(true);
      try {        
        let payload = { name: this.name, phone: this.phone, email: this.email, relation_type: this.relation_type, country_calling_code: "+52"};
        await axios.post(`/api/v1/applicant/${this.applicant_id}/addReference`, payload);
        this.onSuccess = true;
        await this.loadSavedTestimonies();
        this.closeFormPrompt();
      }
      catch (error) {
        this.warn(error);
        this.onError = true;
      }
      this.showLoading(false);
    },
    requestSendWhatsappNotification(reference) {     
      this.currentReference = reference; 
      this.$vs.dialog({
        type: 'confirm',
        color: 'warning',
        title: 'Notificar vía WhatsApp',
        text: `¿Realmente desea enviar la notificación por WhatsApp a <<${reference.name}>> al teléfono <<+${reference.phone.country_calling_code} ${this.phoneFormat(reference.phone.phone)}>>?`,
        acceptText: "Enviar",
        cancelText: 'Cancelar',
        accept: this.doSendWhatsappNotification
      });
    },
    async doSendWhatsappNotification() {
      this.showLoading(true);
      
      try {
        let name = this.currentReference.name.split(' ')[0];
        const payload = {
          user_id: this.userId,
          ref_name: name,
          ref_phone: `+${this.currentReference.phone.country_calling_code}${this.currentReference.phone.phone}`,
        }
        await axios.post(`/api/notification/send-applicant-personal-reference-call`, payload);

        this.$vs.notify({
          title: 'Éxito',
          text: 'La notificación por WhatsApp ha sido enviada exitosamente',
          color: 'success',
          iconPack: 'feather',
          icon: 'icon-check'
        });

      } catch (error) {
        this.warn(error);
        this.$vs.notify({
          title: 'Error',
          text: 'Ha ocurrido un error al enviar la notificación por WhatsApp',
          color: 'danger',
          iconPack: 'feather',
          icon: 'icon-alert-triangle'
        });
      } finally {
        this.showLoading(false);
      }
    },
    requestApplicantSendWhatsappNotification(reference) {     
      this.currentReference = reference; 
      this.$vs.dialog({
        type: 'confirm',
        color: 'warning',
        title: 'Notificar vía WhatsApp',
        text: `Se va a enviar un mensaje al solicitante para que contacte a sus referencias y les solicite completar la información requerida vía telefónica.`,
        acceptText: "Enviar",
        cancelText: 'Cancelar',
        accept: this.doSendApplicantWhatsappNotification
      });
    },
    async doSendApplicantWhatsappNotification() {
      this.showLoading(true);
      
      try {
        const payload = {
          loan_id: this.projectId
        }
        await axios.post(`/api/notification/send-applicant-notification-to-reference-call`, payload);

        this.$vs.notify({
          title: 'Éxito',
          text: 'La notificación por WhatsApp ha sido enviada exitosamente',
          color: 'success',
          iconPack: 'feather',
          icon: 'icon-check'
        });

      } catch (error) {
        this.warn(error);
        this.$vs.notify({
          title: 'Error',
          text: 'Ha ocurrido un error al enviar la notificación por WhatsApp',
          color: 'danger',
          iconPack: 'feather',
          icon: 'icon-alert-triangle'
        });
      } finally {
        this.showLoading(false);
      }
    },
    async updateTestimony(){
      this.onSuccess = false;
      this.onError = false;
      
      this.showLoading(true);
      try {        
        let payload = { name: this.name, phone: this.phone, email: this.email, relation_type: this.relation_type, phone_id: this.currentReference.phone_id, reference_id: this.currentReference.id};
        await axios.put(`/api/v1/applicant/${this.applicant_id}/updateReference`, payload);
        this.onSuccess = true;
        await this.loadSavedTestimonies();
        this.closeFormPrompt();
      }
      catch (error) {
        this.warn(error);
        this.onError = true;
      }
      this.showLoading(false);
    },
    addLocationTestimony(){
      this.resetForm();
      this.showFormPrompt = true;
    },
    resetForm(){
      this.relation_type = null
      this.name = null
      this.phone = null
      this.email = null
      this.onError = null
      this.onSuccess = null      
      this.sent = null
    },
    closeFormPrompt() {
      this.showFormPrompt = false;
      this.resetForm();
    },
    hasError(val){
      return this.errors.has(val);
    },
    errorText(val){
      return this.errors.first(val);
    },
    isSuccess(val){
      let ff = this.fields[val];
      return (ff && ff.required && ff.valid);      
    },

    /* check validation */
    validate(){
      return this.testimonies.length >= 3;
    }
  }
}
</script>